import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoaderState } from '../globalConfig';

@Injectable()
export class LoaderService {

	private loaderSubject = new Subject<LoaderState>();
	loaderState = this.loaderSubject.asObservable();
	loaderObj : LoaderState = {show:false, multiCall:false};
	
  	constructor() { }
  
  	show() {
  		this.loaderObj.show = true;
        this.loaderSubject.next(<LoaderState>this.loaderObj);
    }
	hide() {
		this.loaderObj.show = false;
        this.loaderSubject.next(<LoaderState>this.loaderObj);
    }
	multiShow() {
		this.loaderObj.multiCall = true;
        this.loaderSubject.next(<LoaderState>this.loaderObj);
    }
	multiHide() {
		this.loaderObj.multiCall = false;
        this.loaderSubject.next(<LoaderState>this.loaderObj);
    }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/loader/loader.service.ts